import { ProviderLinkRequest, UserApi, UserLinkRequest, UserPreferences } from "@asd/customer-portal-api";

import { axiosInstance } from ".";

export class UserService {
  static instance: UserService;
  private userApi;

  constructor() {
    if (UserService.instance) {
      return UserService.instance;
    }

    this.userApi = new UserApi(undefined, undefined, axiosInstance);

    UserService.instance = this;
  }

  public async getUserState(options: object = {}) {
    if (!this.userApi) {
      throw new Error("userApi is not initialized");
    }

    try {
      const response = await this.userApi.getUserState(options);
      return response;
    } catch {
      // do nothing
    }
  }

  public async linkUserToParticipant(userLinkRequest: UserLinkRequest, options: object = {}) {
    if (!this.userApi) {
      throw new Error("userApi is not initialized");
    }

    try {
      const response = await this.userApi.linkUserToParticipant(userLinkRequest, options);
      return response;
    } catch {
      // do nothing
    }
  }

  public async linkUserToProvider(providerLinkRequest: ProviderLinkRequest, options: object = {}) {
    if (!this.userApi) {
      throw new Error("userApi is not initialized");
    }

    try {
      const response = await this.userApi.linkUserToProvider(providerLinkRequest, options);
      return response;
    } catch {
      // do nothing
    }
  }

  public async acceptUserLegalAgreements(options: object = {}) {
    if (!this.userApi) {
      throw new Error("userApi is not initialized");
    }
    try {
      const response = await this.userApi.acceptUserLegalAgreements(options);
      return response;
    } catch {
      // do nothing
    }
  }

  public async getUserPreferences(options: object = {}) {
    if (!this.userApi) {
      throw new Error("userApi is not initialized");
    }

    try {
      const response = await this.userApi.getUserPreferences(options);
      return response;
    } catch {
      // do nothing
    }
  }

  public async updateUserPreferences(userPreferences: UserPreferences, options: object = {}) {
    if (!this.userApi) {
      throw new Error("userApi is not initialized");
    }

    try {
      const response = await this.userApi.updateUserPreferences(userPreferences, options);
      return response;
    } catch {
      // do nothing
    }
  }
}

export default new UserService();
